import sihuangContractTemplate from '@/views/person-center/project/contract-comp/sihuang-contract-template/sihuang-contract-template.vue';
import ProjectService from '@/views/person-center/project/project.service.js';
import Service from '@/service/index.js';
import RegExpObj from '@/utils/regExp.js';
import { successMessage, errorMessage } from '@/utils/message.js';
export default {
  components: {
    sihuangContractTemplate
  },
  data() {
    // var massifLevel = (rule, value, callback) => {
    //   if (value === '') {
    //     return callback(new Error('请输入质量等级'));
    //   } else {
    //     callback();
    //   }
    // };
    const contractPeriodValidator = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入流转年限'));
      } else if(value <= 0 || value > 30){
        return callback(new Error('1-30年'));
      } else {
        callback();
      }
    };
    const installmentSumTermValidator = (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入分期付款的期数'));
      } else if(value <= 0 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const installmentPerYearValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入每期多少年'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else {
        callback();
      }
    };
    const installmentPerYearPriceAddPercentValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入每期承包费递增百分比'));
      } else if(value < 0 || value > 100){
        return callback(new Error('0-100'));
      } else {
        callback();
      }
    };
    const contractEffectivePeriodValidator = (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const afterYearsPayNextPriceValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else if(!this.ruleForm.afterDatePayNextPrice) {
        return callback(new Error('请选择日期'));
      } else {
        callback();
      }
    };
    return {
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      checked: true,
      checked1: false,
      textYear: '每年承包费',
      ruleForm: {
        breachMoney: '',  // 违约金
        projectType: '',
        otherAgreements: '', // 其他约定
        userId: '', // 受让人id
        projectId: '',
        contractPeriod: '', // 承包期限
        contractFee: 0, // 承包费合集
        contractFeePerYear: 0, // 每年承包费
        lastDeliverDate: '', // 最晚交付日期
        disputeResolutionWay: '1', // 解决争议途径
        lastPayDate: '', // 剩余交付日期
        payType: 1,
        installmentSumTerm: '',
        installmentPerYear: '',
        installmentPerYearPriceAddPercent: '',
        installmentPriceOfFirst: '',
        remainingPriceOfFirstInstallment: '',
        contractEffectivePeriod: '',
        afterYearsPayNextPrice: '',
        afterDatePayNextPrice: '',
        disposalAncillaryFacilities: '',
        inKindOrOtherMethod: '',
        otherMethod: '',
        remainMoney: '' // 剩余价款
      },
      rules: {
        lastDeliverDate: [
          { required: true, message: '请选择最晚交付日期', trigger: 'blur' }
        ],
        lastPayDate: [
          { required: true, message: '请选择剩余交付日期', trigger: 'blur' }
        ],
        breachMoney: [
          { required: true, message: '请输入违约金', trigger: 'blur' }
        ],
        contractPeriod: [
          { required: true, validator: contractPeriodValidator, trigger: 'blur' }
        ],
        contractFeePerYear: [
          { required: true, message: '请输入每年承包费', trigger: 'blur' }
        ],
        installmentSumTerm: [
          { required: true, validator: installmentSumTermValidator, trigger: 'blur' }
        ],
        installmentPerYear: [
          { required: true, validator: installmentPerYearValidator, trigger: 'blur' }
        ],
        installmentPerYearPriceAddPercent: [
          { required: true, validator: installmentPerYearPriceAddPercentValidator, trigger: 'blur' }
        ],
        afterYearsPayNextPrice: [
          { required: true,  validator: afterYearsPayNextPriceValidator, trigger: 'change' }
        ],
        contractEffectivePeriod: [
          { required: true, validator: contractEffectivePeriodValidator, trigger: 'blur' }
        ],
        remainingPriceOfFirstInstallment: [
          { required: true, message: '请输入第一期价款剩余金额', trigger: 'blur' }
        ],
        inKindOrOtherMethod: [
          { required: true, message: '请输入以实物或者实物折资方式', trigger: 'blur' }
        ],
        disposalAncillaryFacilities: [
          { required: true, message: '请输入地上附着物处置方式', trigger: 'blur' }
        ],
        disputeResolutionWay: [
          { required: true, message: '请选择解决争议途径', trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      createContractInfo: {
        projectAssets: {}
      },
      projectSubType: '', // 子类
      disputeWay: null, // 争议解决途径
      contractPeriod: null, // 承包期限
      previewContract: null, // 预览合同的信息
      massifType: null, // 地块类型
      payTypeArr: null
    };
  },
  created() {
    let fromDate = this.$route.query;
    this.ruleForm.userId = fromDate.userId;
    this.ruleForm.projectId = fromDate.id;
    this.ruleForm.projectType = fromDate.projectType;
    this.projectSubType = fromDate.projectSubType;
    this.getDictList();
  },
  watch: {
    'ruleForm.installmentPriceOfFirst'(newName, oldName) {
      if(newName !== oldName) {
        this.ruleForm.remainingPriceOfFirstInstallment = this.ruleForm.installmentPriceOfFirst - (this.createContractInfo.marginSubServiceFee);
      }
    }
  },
  computed: {
  },
  mounted() {
    this.getContractData();
  },
  methods: {
    contractPeriodV(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请输入承包年限'));
      } else if(Number(value) < 1 || Number(value) > 50){
        return callback(new Error('1-50年'));
      } else if(!RegExpObj.num.test(this.ruleForm.contractPeriod)){
        return callback(new Error('请输1-50的整数'));
      } else {
        callback();
      }
    },
    installmentPriceOfFirstValidator(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请输入第一期价款金额'));
      } else if(value < this.createContractInfo.marginSubServiceFee){
        return callback(new Error('不能小于竞价保证金-服务费'));
      } else {
        callback();
      }
    },
    change(){
      this.$forceUpdate();
    },
    // 获取用户类型 字典查询
    getDictList () {
      const obj = {
        DISPUTE_RESOLUTION_WAY: 'disputeWay',
        CONTRACT_PERIOD: 'contractPeriod',
        PROJECT_TYPE: 'massifType',
        PAY_TYPE: 'payTypeArr'
      };
      Object.keys(obj).forEach((key) => {
        Service.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            // this[obj[key]] = res.data;
            // 四荒项目分类取的是项目二级分类
            if(obj[key] === 'massifType') {
              let tempList = res.data.find(item => item.code === '4');
              if(tempList) {
                this[obj[key]] = tempList.list;
              }
            } else {
              this[obj[key]] = res.data;
            }
          }
        });
      });
    },
    // 数据回显
    getContractData() {
      ProjectService.toCreateContract(this.ruleForm.projectId, this.ruleForm.userId, this.ruleForm.projectType).then(res => {
        if (res && res.code === '0') {
          this.createContractInfo =  res.data;
          for (let key in this.createContractInfo) {
            if (this.ruleForm.hasOwnProperty(key)) {
              this.ruleForm[key] = this.createContractInfo[key];
              // if(res.data.marginSubServiceFee < 0) {
              //   this.createContractInfo.marginSubServiceFee = 0;
              // }
              // 第一期价款金额如果小于0 则等于0
              if(res.data.installmentPriceOfFirst < 0) {
                this.createContractInfo.installmentPriceOfFirst = 0;
              }
              if(key === 'disputeResolutionWay') {
                if(this.ruleForm.disputeResolutionWay) {
                  this.ruleForm.disputeResolutionWay = this.ruleForm.disputeResolutionWay && this.ruleForm.disputeResolutionWay.toString();
                }
              }
              if(key === 'remainingPriceOfFirstInstallment') {
                if(!res.data.remainingPriceOfFirstInstallment) {
                  this.ruleForm.remainingPriceOfFirstInstallment = this.createContractInfo.installmentPriceOfFirst - this.createContractInfo.marginSubServiceFee;
                }
              }
              // 其他途径复选
              if(key === 'disputeResolutionWay') {
                if(res.data.disputeResolutionWay) {
                  this.checked1 = true;
                }
              }
            }
          }
          if( res.data.projectAssets && res.data.projectAssets.length ) {
            this.ruleForm['projectAssets'] = this.createContractInfo.projectAssets;
          }
          if(!this.ruleForm.contractPeriod) {
            this.ruleForm.contractPeriod = this.datedifference(this.createContractInfo.startTime, this.createContractInfo.endTime);
            this.handler();
          }
        }
      });
    },
    // 计算每年成交费
    handler() {
      if(this.createContractInfo.sumCurrentPrice > 0 && this.createContractInfo.sumArea > 0 && Number(this.ruleForm.contractPeriod)>0 ) {
        this.ruleForm.contractFeePerYear = (this.createContractInfo.sumCurrentPrice/this.createContractInfo.sumArea/Number(this.ruleForm.contractPeriod)).toFixed(2);
      } else {
        this.ruleForm.contractFeePerYear = 0;
      }
    },
    previousStep () {
      this.$router.back();
    },
    // 计算承包年限
    datedifference(sDate1, sDate2) { // sDate1和sDate2是2006-12-18格式
      var dateSpan, iDays;
      sDate1 = Date.parse(sDate1);
      sDate2 = Date.parse(sDate2);
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = (dateSpan / (24 * 3600 * 1000)) / 365;
      var y = String(iDays).indexOf('.') + 1; // 获取小数点的位置
      // console.log(iDays, String(iDays).split('.'), 'iDays.split');
      if(y > 0) {
        if(String(iDays).split('.')[0] === '0') {
          return iDays = iDays.toFixed(0);
        } else {
          return iDays = iDays.toFixed(1);
        }
      } else {
        return iDays;
      }
    },
    // 预览合同
    previewBtn() {
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = true;
          this.submit(false);
        } else {
          return false;
        }
      });
    },
    // 立即提交
    test() {
      console.log('1', this.$refs['signUpForm'], this.ruleForm);
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交合同信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit(true);
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 确认提交按钮
    submit(isSave) {
      // if(!isSave) {
      //   this.ruleForm.projectAssets = this.ruleForm.projectAssets.map(item => ({
      //     ...item,
      //     assetsInfo: JSON.stringify(item.assetsInfo)
      //   }));
      // };
      // 保存接口传参
      ProjectService.createContract({
        isSave: isSave,
        ...this.ruleForm
      }).then(res => {
        if(isSave) {
          if (res && res.code === '0') {
            successMessage('创建成功');
            this.$router.push('/person-center/project/roll-out-project/list');
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          } else {
            errorMessage('创建失败');
          }
        } else {
          ProjectService.displayWoodsContract(
            this.ruleForm.projectId,
            this.ruleForm.projectType,
            this.ruleForm.userId,
            '1'
          ).then(res => {
            if (res && res.code === '0') {
              this.previewContract = res.data;
              // this.getContractData();
            }
          });
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('创建失败');
        }
      });
    }
  }
};
